import $ from 'jquery';
import { onTransitionEnd } from '../../helpers/ontransitionend';

/**
* Renders alert popup
*/
export default class Alert {
    /**
     * @param {Object} options - alerts data
     * @param {('error'|'success'|'info')} options.type - alerts type
     * @param {string} options.header - alerts header
     * @param {string} options.message - alerts message (allow html)
     */
    constructor(options = {}) {
        this.options = $.extend(true, {
            classes: {
                hidden: 'alert--hidden',
                popup: 'alert--popup',
                error: 'alert--error',
                success: 'alert--success',
                info: 'alert--info',
                close: 'alert__close',
                header: 'alert__header',
                message: 'alert__message',
                container: 'alert__container',
            },
        }, options);

        this.init(); 
    }

    init() {
        this.createContainer();
        this.build();
        this.closeAlert();
    }

    build() {
        this.$container.innerHTML = '';

        const alert = document.createElement('div'),
            header = document.createElement('div'),
            message = document.createElement('div'),
            close = document.createElement('button');

        if (this.options.type === 'error') {
            alert.classList.add('alert', this.options.classes.error);
        } else if (this.options.type === 'success') {
            alert.classList.add('alert', this.options.classes.success);
        } else {
            alert.classList.add('alert', this.options.classes.info);
        }

        alert.classList.add(this.options.classes.hidden);
        alert.classList.add(this.options.classes.popup);
        header.classList.add(this.options.classes.header);
        message.classList.add(this.options.classes.message);
        close.classList.add(this.options.classes.close);

        header.innerText = this.options.header;
        message.innerHTML = this.options.message;

        alert.append(header, message, close);

        this.$container.append(alert);

        setTimeout(() => alert.classList.remove(this.options.classes.hidden), 0);

        this.$close = close;
        this.$alert = alert;
    }

    createContainer() {
        if (document.querySelector('.' + this.options.classes.container)) {
            this.$container = document.querySelector('.' + this.options.classes.container);
        } else {
            const alertContainer = document.createElement('div');
            alertContainer.classList.add(this.options.classes.container);
            document.body.append(alertContainer);
            this.$container = alertContainer;
        }
    }

    closeAlert() {
        const handler = () => {
            this.$alert.classList.add(this.options.classes.hidden);
            onTransitionEnd(this.$alert).then(() => {
                this.$alert.remove();
            });
        }

        this.$close.addEventListener('click', handler);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/alerts/alert.js